











import { NoResult } from '@/components'
import { Component, Vue, Watch } from 'vue-property-decorator'
import TopFilter from './TopFilter.vue'
import LeftMenu from './LeftMenu.vue'
import PaperList from './PaperList/PaperList.vue'

@Component({
  components: { LeftMenu, NoResult, PaperList, TopFilter }
})
export default class Main extends Vue {}
